<template>
  <div class="panel-wrap">
    <div class="two-column-grid">
      <!-- Left Column -->
      <div class="column">
        <div class="field">
          <label>复诊情况</label>
          <a-tooltip :title="diseaseStageText" placement="top">
            <div class="readonly-input">
              <span class="readonly-text">{{ diseaseStageText }}</span>
            </div>
          </a-tooltip>
        </div>
        <div class="field">
          <label>疾病诊断</label>
          <a-tooltip :title="diagnosisText" placement="top">
            <div class="readonly-input">
              <span class="readonly-text">{{ diagnosisText }}</span>
            </div>
          </a-tooltip>
        </div>
        <div class="field">
          <label>用药结束时间</label>
          <a-tooltip :title="medicationEndTimeText" placement="top">
            <div class="readonly-input">
              <span class="readonly-text">{{ medicationEndTimeText }}</span>
            </div>
          </a-tooltip>
        </div>
      </div>

      <!-- Right Column -->
      <div class="column">
        <div class="field">
          <label>本次用药状态</label>
          <a-tooltip :title="touchStageText" placement="top">
            <div class="readonly-input">
              <span class="readonly-text">{{ touchStageText }}</span>
            </div>
          </a-tooltip>
        </div>
        <div class="field">
          <label>当前用药</label>
          <a-tooltip :title="medicinesText" placement="top">
            <div class="readonly-input">
              <span class="readonly-text">{{ medicinesText }}</span>
            </div>
          </a-tooltip>
        </div>
        <div class="field">
          <label>情绪状态</label>
          <a-select v-model:value="emotionValue" placeholder="请选择" :options="emotionOptions" />
        </div>
      </div>
    </div>

    <!-- Full Width Selection Fields -->
    <div class="selection-fields">
      <div class="field">
        <label>响应特点</label>
        <a-select
          v-model:value="responsePatternValue"
          placeholder="请选择"
          :options="responseOptions"
        />
      </div>
      <div class="field">
        <label>触达偏好</label>
        <a-select
          v-model:value="contactPreferenceValue"
          placeholder="请选择"
          :options="contactOptions"
        />
      </div>
      <div class="field">
        <label>沟通配合度</label>
        <a-select
          v-model:value="cooperationValue"
          placeholder="请选择"
          :options="cooperationOptions"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'
import { formatMedicationEndTime } from '@/utils'
import { createFieldModel } from '../../hooks/useFieldModel'

const props = defineProps({
  form: {
    type: Object,
    default: () => ({})
  },
  emotionOptions: {
    type: Array,
    default: () => []
  },
  responseOptions: {
    type: Array,
    default: () => []
  },
  contactOptions: {
    type: Array,
    default: () => []
  },
  cooperationOptions: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update-field'])

const emotionValue = createFieldModel(() => props.form, 'portrait', 'emotion', emit, {
  select: true
})
const responsePatternValue = createFieldModel(
  () => props.form,
  'portrait',
  'responsePattern',
  emit,
  { select: true }
)
const contactPreferenceValue = createFieldModel(
  () => props.form,
  'portrait',
  'contactPreference',
  emit,
  { select: true }
)
const cooperationValue = createFieldModel(() => props.form, 'portrait', 'cooperation', emit, {
  select: true
})

const diseaseStageText = computed(() => props.form?.portrait?.followUpCountLabel || '--')
const diagnosisText = computed(() => props.form?.portrait?.diagnosis || '--')
const medicationEndTimeText = computed(() => formatMedicationEndTime(props.form?.portrait || {}))
const touchStageText = computed(
  () => props.form?.portrait?.currentCourseMedicationDaysLabel || '--'
)
const medicinesText = computed(() => props.form?.portrait?.currentMedicinesText || '--')
</script>

<style lang="scss" scoped>
.panel-wrap {
  padding-top: 8px;
}

.two-column-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 16px;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.selection-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  min-width: 0;
  box-sizing: border-box;

  label {
    display: block;
    margin-bottom: 8px;
    color: #333;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
  }

  .readonly-input {
    min-height: 36px;
    padding: 7px 12px;
    border: 1px solid #ececec;
    border-radius: 4px;
    background: #fafafa;
    color: #a3a3a3;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    user-select: none;
    width: 100%;
    overflow: hidden;
  }

  .readonly-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  :deep(.ant-input),
  :deep(.ant-select-selector) {
    height: 36px;
    border: 1px solid #e7e7e7;
    border-radius: 4px;
    box-shadow: none;
    padding: 5px 12px;
    color: #333;
    font-size: 14px;
    line-height: 20px;
    background: #fff;
    box-sizing: border-box;
    width: 100%;
  }

  :deep(.ant-select) {
    width: 100%;
    max-width: 100%;
    flex-shrink: 0;
  }

  :deep(.ant-input::placeholder),
  :deep(.ant-select-selection-placeholder) {
    color: #b8b8b8;
  }

  :deep(.ant-select-selector) {
    width: 100% !important;
    max-width: 100%;
    padding-left: 12px !important;
    padding-right: 8px !important;
  }
}
</style>
